// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Input,
  Label,
  Tooltip,
  Toastr,
} from "../../../../revvComponents";
import FolderManagerPopup from "./FolderManagerPopup";

// Actions Imports
import {
  addAcceptorsDetailsAction,
  createBulkDocumentAction,
} from "../../../../actions/DocumentActions";
import {
  getAssetFolderTreeAction,
  getAssetFolderContentAction,
} from "../../../../actions/AssetActions/assetActions";

import { createBulkDocumentsService } from "../../../../actions/FieldsSetting/fieldsSettingService";

import { fetchAllDocumentTemplates } from "../../../../actions/DocumentTemplateActions/templateActions";

import SuccessCreationPopup from "./SuccessCreationPopup";
import SelectTemplatePopup from "./SelectTemplatePopup";
import CreationErrorMessage from "./CreationErrorMessage";
import { IntegrationsActions } from "../../../../actions";

// Internal Imports
import { GlobalUtils } from "../../../../utils";
import { IMAGE_URLS, ASSET } from "../../../../constants";
import { getFieldValue } from "../../../../utils/quotationUtils";
import LZLoader from "../../../../commonComponents/LZLoader";

const {
  truncateString,
  getAssetFolderUrl,
  readDataFromLocalStorage,
  handleApiErrMsg,
} = GlobalUtils;
const { ASSET_PAGE_URL } = ASSET;
const { FOLDER_ICO, SHIELD } = IMAGE_URLS;
const { authenticateCRM } = IntegrationsActions;
class CreateDocumentPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTemplateSelectionPopup: false,
      errorMsg: "",
      showMultiDocCreationLoader: false,
      sucessBulkUploadPopup: false,
      creationErrorMessage: false,
      showFolderManagerPopup: false,
      selectedBreadCrumPath: "All documents",
      breadcrumbData: [],
      selectedDocCreateType: "documemntCreate",
      urlPathname: ASSET_PAGE_URL,
      selectedFolderID: 0,
      showBoxAuthLoader: false,
      esignWarningText: "",
    };
  }

  componentDidMount() {
    const payload = `page_num=1`;
    this.props.fetchAllDocumentTemplates();
    this.props
      .getAssetFolderContentAction(payload, null, "all")
      .then(() => {
        console.debug("Success");
      })
      .catch(error => {
        console.debug(
          `Fields => get folder structure for doc creation => _onInit Create Document Popup => Error : ${error}`,
        );
      });
  }

  _closePopup = () => {
    this.props.closePopup();
  };

  _createDocuments = () => {
    const {
      selectedRows,
      transformedData,
      templateId,
      playFieldColumnDefs,
      revvFieldDefs,
    } = this.props;
    const { selectedDocCreateType } = this.state;
    const selectedRowsData = [];

    // check if there is any primary field or not
    // and if any field is primary field, add that value in each row
    // this is used for document creation
    const primaryFieldId =
      playFieldColumnDefs.length > 0 && playFieldColumnDefs[0].isPrimaryKey
        ? playFieldColumnDefs[0].name
        : null;
    const primaryField =
      primaryFieldId && revvFieldDefs && revvFieldDefs[primaryFieldId]
        ? revvFieldDefs[primaryFieldId]
        : null;
    selectedRows.forEach((flag, index) => {
      if (flag) {
        const data = transformedData[index];
        let rowfieldData = {};
        Object.keys(data).forEach(fieldId => {
          if (fieldId.startsWith("METAG")) {
            const fieldName = fieldId.split("-")[2];
            if ("meta_data" in rowfieldData) {
              rowfieldData.meta_data.TEMPLATE[fieldName] = data[fieldId];
            } else {
              rowfieldData = {
                ...rowfieldData,
                meta_data: {
                  TEMPLATE: {
                    [fieldName]: data[fieldId],
                  },
                },
              };
            }
          } else {
            rowfieldData[fieldId] = data[fieldId];
          }
        });

        const rowData = {
          fields: rowfieldData,
        };
        if (primaryField) {
          const fieldValue = getFieldValue({
            ...primaryField,
            value: data[primaryField.id],
          });
          rowData.doc_name = fieldValue;
        }

        selectedRowsData.push(rowData);
      }
    });

    // create actions
    let action = null;
    if (selectedDocCreateType === "documemntCreate") {
      action = "create_doc";
    } else if (selectedDocCreateType === "esign") {
      action = "esignatures";
    }
    const creationPayload = {
      action,
      folder_id: this.state.selectedFolderID || 0,
      doc_name_prefix: this.props.templateTitle,
      ds_payload: {
        datasource: this.props.dataSourceSelected,
        object_selected: this.props.currentSelectedObject,
      },
      payload: selectedRowsData,
    };
    createBulkDocumentsService(templateId, creationPayload)
      .then(() => {
        this.setState({
          showMultiDocCreationLoader: false,
          sucessBulkUploadPopup: true,
        });
      })
      .catch(() => {
        this.setState({
          showMultiDocCreationLoader: false,
          creationErrorMessage: true,
        });
      });
  };

  _gotoMyDocs = () => {
    this.props.history.push("/assets");
  };

  _getBreadCrumbDetails = (breadCrumb, index, len) => {
    let breadCru = "";
    if (breadCrumb.name !== "All" && index !== len - 1) {
      breadCru = truncateString(breadCrumb.name, 3, true, 2);
    } else if (index === len - 1 && breadCrumb.name.length > 12) {
      breadCru = truncateString(breadCrumb.name, 5, true, 2);
    } else breadCru = breadCrumb.name;
    return breadCru;
  };

  _getFolderPath = (breadcrumbData, folderID) => {
    const breadcrumbPath = [];
    breadcrumbData.forEach((bc, index) => {
      if (bc.name) {
        breadcrumbPath.push(
          `${this._getBreadCrumbDetails(bc, index, breadcrumbData.length)}/`,
        );
      }
    });
    const urlPathData = breadcrumbData[breadcrumbData.length - 1];
    const urlPathname = getAssetFolderUrl(urlPathData.name, urlPathData.id);
    this.setState({
      selectedBreadCrumPath: breadcrumbPath.join(""),
      showFolderManagerPopup: false,
      breadcrumbData,
      urlPathname,
      selectedFolderID: folderID,
    });
  };

  _openTemplateSelectionPopup = () => {
    this.setState({ showTemplateSelectionPopup: true });
  };

  _closeTemplateSelectionPopup = () => {
    this.setState({ showTemplateSelectionPopup: false });
  };

  // _updateSelectedTemplateID = id => {
  //   this.setState({ selectedTemplateID: id });
  // };
  _checkEsignPossible = () => {
    const { fieldsList } = this.props;
    let textValue = false;
    const recipientValue = fieldsList.filter(
      item => item.filler_type === "RECIPIENT",
    );
    if (
      Array.isArray(fieldsList) &&
      fieldsList.length > 0 &&
      recipientValue.length > 0
    ) {
      textValue =
        "There are some field(s) assigned to recipient. You can create documents only or unassign the fields to proceed.";
    } else if (this.props.signerIDsList.length === 0) {
      textValue = "There are no signature fields in this template.";
    } else if (
      Array.isArray(this.props.signerIDsList) &&
      this.props.signerIDsList.length > 0
    ) {
      let count = false;
      let checkEsign = true;
      this.props.signerIDsList.forEach(item => {
        const getData = fieldsList.find(value => value.id === item);
        if (getData.signer_email === "") {
          if (this.props.transformedData[0][item] === undefined) {
            textValue = "You have not mapped all the signer fields.";
            count = true;
            checkEsign = false;
          } else if (
            this.props.transformedData[0][item] !== undefined &&
            Object.keys(this.props.transformedData[0][item]).length === 3
          ) {
            checkEsign = false;
          }
          if (
            this.props.transformedData[0][item] !== undefined &&
            Object.keys(this.props.transformedData[0][item]).length !== 3
          ) {
            textValue = "Its look like signatories are not fully mapped.";
            count = false;
            checkEsign = false;
          }
        }
      });
      if (count && checkEsign) {
        textValue = "You have not mapped the signer fields.";
      }
    }
    return textValue;
  };

  _onSelectChange = value => {
    if (value === "esign") {
      this.setState({
        selectedDocCreateType: value,
        esignWarningText: this._checkEsignPossible(),
      });
    } else {
      this.setState({
        selectedDocCreateType: value,
        esignWarningText: false,
      });
    }
  };

  closeFolderPopup = () => this.setState({ showFolderManagerPopup: false });

  _getTemplateSelectionView = () => (
    <SelectTemplatePopup
      templates={this.props.documentTemplates}
      selectTemplate={this._updateSelectedTemplateID}
      closeTemplateSelectionPopup={this._closeTemplateSelectionPopup}
    />
  );

  _toggleLoader = flag => {
    this.setState({ showBoxAuthLoader: flag });
  };

  _connectToBoxAccount = () => {
    this._toggleLoader(true);
    const { clientId, clientSecret, redirectUrl, instanceUrl } =
      this.props.boxConfig;
    const config = {
      crm: "BOX",
      instance_url: instanceUrl.trim(),
      redirect_url: redirectUrl.trim(),
      client_id: clientId.trim(),
      client_secret: clientSecret.trim(),
      oauth_type: "user",
    };
    this._toggleLoader(true);
    this.props
      .authenticateCRM(config, window.location.pathname)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _decideSendForEsignCondition = () => {
    const {
      boxConfig: { isCRMAuthenticated },
      isUserLoggedIntoBoxAcnt,
    } = this.props;

    if (!isCRMAuthenticated) {
      return (
        <div className="select-type-create-doc">
          <Label className="select-type-label-name">
            <Input
              type="radio"
              name="choose_creation_type"
              value
              disabled
              data-test="send-for-esign-data-studio"
            />
            Send for esign
          </Label>
          <div className="datastudio-box-connect-esign">
            <FontAwesomeIcon icon={["far", "plug"]} /> Integrate with Box &nbsp;
            <Tooltip
              placement="bottom"
              overlay="Contact your admin to integrate with Box to proceed with eSignature"
              align={{
                offset: [6, 0],
              }}>
              <span className="btn-icon">
                <FontAwesomeIcon icon={["far", "info-circle"]} />
              </span>
            </Tooltip>
          </div>
        </div>
      );
    }

    if (!isUserLoggedIntoBoxAcnt) {
      return (
        <div className="select-type-create-doc">
          <Label className="select-type-label-name">
            <Input
              type="radio"
              name="choose_creation_type"
              value
              disabled
              data-test="send-for-esign-data-studio"
            />
            Send for esign
          </Label>
          {this.state.showBoxAuthLoader ? (
            <div>
              <FontAwesomeIcon icon={["fas", "spinner"]} className="fa-spin" />
            </div>
          ) : (
            <div
              className="datastudio-box-connect-esign"
              role="button"
              tabIndex="0"
              onKeyPress={() => {}}
              onClick={this._connectToBoxAccount}>
              <FontAwesomeIcon icon={["far", "link"]} /> Connect to box &nbsp;
              <Tooltip
                placement="bottom"
                overlay="Connect to box to send for eSignature"
                align={{
                  offset: [6, 0],
                }}>
                <span className="btn-icon">
                  <FontAwesomeIcon icon={["far", "info-circle"]} />
                </span>
              </Tooltip>
            </div>
          )}
        </div>
      );
    }
    return <Fragment />;
  };

  _getCreateDocPopupView = () => {
    const { selectedDocCreateType } = this.state;
    const { selectedRows } = this.props;
    // Default size for file type
    const iconWidth = "20px";
    const iconHeight = "26px";
    const buttonValue = "Create Documents";
    const rowsSelectedCount =
      Array.isArray(selectedRows) && selectedRows.length > 0
        ? selectedRows.filter(sel => sel).length
        : 0;
    return (
      <div>
        <div
          className="modal-heading withprogress"
          data-test="multidocpopup-modal-heading">
          <div>Create documents in bulk with data playfield</div>
        </div>
        <div className="multidocpopup-info addproduct-info">
          <div>
            <img
              src={SHIELD}
              alt="Revv"
              className="info-signer-icon"
              width="35"
            />
          </div>
          <div className="info-subtitle">
            Connect your data source, map fields, fetch field value, select
            required rows and create document
          </div>
        </div>
        <div className="multidocpopup-step">
          {/* <div className="step-header">STEP 1</div> */}
          <div className="step-text">{`Total number of rows selected ${rowsSelectedCount}`}</div>
          {/* {this._selectDocumentType()} */}
        </div>
        <div className="multidocpopup-step">
          <div className="step-header">STEP 1</div>
          <div className="step-text">Select what would you like to do</div>
          <div className="select-doc-creation-option">
            <div className="select-type-create-doc">
              <Label className="select-type-label-name">
                <Input
                  type="radio"
                  name="choose_creation_type"
                  value
                  checked={selectedDocCreateType === "documemntCreate"}
                  onChange={() => this._onSelectChange("documemntCreate")}
                  data-test="create-documents-only-data-studio"
                />
                Create documents only
              </Label>
            </div>

            {!this.props.isBoxEsignFlow ||
            (this.props.isBoxEsignFlow &&
              this.props.boxConfig.isCRMAuthenticated &&
              this.props.isUserLoggedIntoBoxAcnt) ? (
              <div className="select-type-create-doc">
                <Label className="select-type-label-name">
                  <Input
                    type="radio"
                    name="choose_creation_type"
                    value
                    checked={selectedDocCreateType === "esign"}
                    onChange={() => this._onSelectChange("esign")}
                    data-test="send-for-esign-data-studio"
                  />
                  Send for esign
                </Label>
              </div>
            ) : (
              this._decideSendForEsignCondition()
            )}
            <div className="select-type-create-doc">
              <Label className="select-type-label-name">
                <Input
                  type="radio"
                  name="choose_creation_type"
                  value
                  checked={selectedDocCreateType === "acceptance"}
                  onChange={() => this._onSelectChange("acceptance")}
                  data-test="Send-for-acceptance-data-studio"
                  disabled
                />
                Send for acceptance
              </Label>
              <div className="data-studio-coming-soon">coming soon</div>
            </div>
          </div>
        </div>
        {this.state.esignWarningText && (
          <div className="send-for-esign-error-info datastudio-esign-warning-info">
            <div>
              <FontAwesomeIcon icon={["far", "exclamation-triangle"]} />
            </div>
            <div className="info-subtitle"> {this.state.esignWarningText} </div>
          </div>
        )}
        {this.props.currentSelectedObject !== "Opportunity" && (
          <div className="multidocpopup-step">
            <div className="step-header">STEP 2</div>
            <div className="step-text">
              Select a folder to store these documents. You can access from
              there later
            </div>
            <div className="folder-path">
              Documents will be created in{" "}
              <img
                src={FOLDER_ICO}
                className="folder-icon"
                alt="icons"
                width={`${iconWidth}`}
                height={`${iconHeight}`}
              />{" "}
              {this.state.selectedBreadCrumPath.substring(
                0,
                this.state.selectedBreadCrumPath.length - 1,
              )}{" "}
              <div
                role="button"
                tabIndex={0}
                className="change-folder"
                onClick={() => {
                  this.setState({ showFolderManagerPopup: true });
                }}
                onKeyPress={() => {}}>
                Change folder
              </div>
            </div>
          </div>
        )}

        {this.state.errorMsg && (
          <div className="error-msg">
            {ReactHtmlParser(this.state.errorMsg)}
          </div>
        )}
        <section className="createquotepopup-footer popup-footer clearfix create-multi-doc-footer">
          {/* {this.state.disableBtn && (
            <Tooltip
              placement="top"
              align={{
                offset: [0, 4],
              }}
              overlay={"Select rows for which you want to create documents"}>
              <div className="multidocpopup-actions">
                <Button
                  className="revv-btn-success"
                  onClick={() => this._createBulkDocuments()}
                  data-test="templatedetails-preview-button"
                  disabled={this.state.disableBtn}>
                  {buttonValue}
                </Button>
              </div>
            </Tooltip>
          )} */}
          {/* {!this.state.disableBtn && ( */}
          <div className="multidocpopup-actions">
            <Button
              className="revv-btn-success"
              disabled={
                !selectedDocCreateType ||
                (this.state.selectedDocCreateType === "esign" &&
                  this.state.esignWarningText) ||
                (this.state.selectedDocCreateType === "esign" &&
                  this.props.isBoxEsignFlow &&
                  (!this.props.boxConfig.isCRMAuthenticated ||
                    !this.props.isUserLoggedIntoBoxAcnt))
              }
              onClick={() => this._createDocuments()}
              data-test="templatedetails-preview-button">
              {buttonValue}
            </Button>
          </div>
          {/* )} */}
        </section>
      </div>
    );
  };

  _getCreateDocumentPopupView = () => {
    if (this.state.showTemplateSelectionPopup) {
      return this._getTemplateSelectionView();
    }
    return this._getCreateDocPopupView();
  };

  render() {
    if (this.state.sucessBulkUploadPopup) {
      return (
        <SuccessCreationPopup
          onClose={this._closePopup}
          urlPathname={this.state.urlPathname}
        />
      );
    }
    if (this.state.creationErrorMessage) {
      return (
        <CreationErrorMessage
          onClose={this._closePopup}
          urlPathname={this.state.urlPathname}
        />
      );
    }

    return (
      <Fragment>
        <Modal
          open
          onClose={this._closePopup}
          center
          closeOnOverlayClick={false}
          className={`${
            this.state.showFolderManagerPopup ? "hide-modal" : ""
          }`}>
          <div className="multidocpopup-container">
            {this.state.showMultiDocCreationLoader && (
              <LZLoader
                theme="light"
                className="loader-bg-color"
                label="Please wait till your field data is getting validated."
              />
            )}
            {this._getCreateDocumentPopupView()}
            {/* ----------- Modal Heading Section ----------- */}
          </div>
        </Modal>
        {this.state.showFolderManagerPopup && (
          <FolderManagerPopup
            closePopup={this.closeFolderPopup}
            getFolderPath={this._getFolderPath}
            breadcrumbData={this.state.breadcrumbData}
            assetBreadcrumbData={this.props.assetBreadcrumbData}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { assetBreadcrumbData } = state.AssetStore;
  const {
    documentTemplates,
    template: { id: templateId, title: templateTitle },
  } = state.TemplateStore;
  const {
    selectedRows,
    transformedData,
    playFieldColumnDefs,
    revvFieldDefs,
    dataSourceSelected,
    currentSelectedObject,
    fieldsList,
    signerIDsList,
  } = state.FieldsSettingStore;

  const { crmConfig, crmAllUsers } = state.SettingsStore;

  // Data Mutation For Box Data
  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  const loggedInCrmUser =
    crmAllUsers.find(i => i.user_id === CURRENT_USER.id) || {};
  const boxCrmConfig =
    crmConfig &&
    crmConfig.crm &&
    Array.isArray(crmConfig.crm) &&
    crmConfig.crm.find(item => item.crm === "BOX");

  let boxConfig = {};
  if (Object.keys(boxCrmConfig).length > 0) {
    boxConfig = {
      isCRMAuthenticated: boxCrmConfig.is_authenticated,
      clientId: boxCrmConfig.client_id,
      clientSecret: boxCrmConfig.client_secret,
      instanceUrl: boxCrmConfig.instance_url,
      redirectUrl: boxCrmConfig.redirect_url,
    };
  }

  // Check if org has box esign flow
  const appFlag = readDataFromLocalStorage("appFlag");
  const isBoxEsignFlow = appFlag.esign_type && appFlag.esign_type === "BOX";

  return {
    templateId,
    transformedData,
    revvFieldDefs,
    selectedRows,
    templateTitle,
    documentTemplates,
    assetBreadcrumbData,
    playFieldColumnDefs,
    dataSourceSelected,
    currentSelectedObject,
    boxConfig,
    isUserLoggedIntoBoxAcnt: Object.keys(loggedInCrmUser).length > 0,
    isBoxEsignFlow,
    fieldsList,
    signerIDsList,
  };
};

const mapDispatchToProps = {
  fetchAllDocumentTemplates,
  createBulkDocumentAction,
  addAcceptorsDetailsAction,
  getAssetFolderTreeAction,
  getAssetFolderContentAction,
  authenticateCRM,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateDocumentPopup));
